module.exports = __webpack_public_path__ + "08_hair_black.c408a46a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/08_hair_black.png
// module id = 3HhR
// module chunks = 0